module.exports = __webpack_public_path__ + "img/Vision strategy values Icon - charcoal.bec9b212.svg";